import { endpoint } from './endpoint.js';
import {
  MeDraftOffersQuerySchema,
  MeDraftOffersResponseSchema,
} from '../schemas/me-draft-offers.js';

export const meDraftOffers = {
  list: endpoint('GET', '/me/draft-offers', MeDraftOffersQuerySchema, MeDraftOffersResponseSchema),
};
